import { lazy, Suspense } from "react";
import HeroSection from "@/components/HeroSection";
import TrustBar from "@/components/TrustBar";
import TopRoutesSection from "@/components/TopRoutesSection";
import AirportHubsSection from "@/components/AirportHubsSection";
import HowItWorksSection from "@/components/HowItWorksSection";
import ServicesSection from "@/components/ServicesSection";
import FAQSection from "@/components/FAQSection";
import WhatsAppButton from "@/components/WhatsAppButton";
import { useFaqs } from "@/hooks/useFaqs";
import { useSeo, faqSchema, SITE_URL } from "@/lib/seo";


const FleetSection = lazy(() => import("@/components/FleetSection"));
const FeaturesSection = lazy(() => import("@/components/FeaturesSection"));
const StatsSection = lazy(() => import("@/components/StatsSection"));
const TestimonialsSection = lazy(() => import("@/components/TestimonialsSection"));
const CTASection = lazy(() => import("@/components/CTASection"));
const Footer = lazy(() => import("@/components/Footer"));


const Index = () => {
  const faqs = useFaqs();
  useSeo({

    title: "Private Airport Transfers in Punta Cana & Dominican Republic | Express Punta Cana",
    description:
      "Book private airport transfers in the Dominican Republic. Fixed prices, meet & greet at PUJ, SDQ, LRM, STI and POP, licensed drivers and 24/7 service.",
    path: "/",
    keywords:
      "punta cana airport transfer, puj transfer, private transfer dominican republic, bavaro shuttle, cap cana transportation",
    schema: [
      faqSchema(faqs.map((f) => ({ question: f.q, answer: f.a }))),
      {
        "@type": "Service",
        "@id": `${SITE_URL}/#transfer-service`,
        name: "Private airport transfer",
        serviceType: "Airport transfer",
        provider: { "@id": `${SITE_URL}/#business` },
        areaServed: { "@type": "Country", name: "Dominican Republic" },
        availableChannel: {
          "@type": "ServiceChannel",
          serviceUrl: `${SITE_URL}/transfers`,
          availableLanguage: ["en", "es"],
        },
      },
    ],
  });

  return (
    <main>
      <HeroSection />
      <TrustBar />
      <TopRoutesSection />
      <AirportHubsSection />
      <HowItWorksSection />
      <ServicesSection />
      <Suspense fallback={null}>
        <FleetSection />
        <FeaturesSection />
        <StatsSection />
        <TestimonialsSection />
      </Suspense>
      <FAQSection />
      <Suspense fallback={null}>
        <CTASection />
        <Footer />
      </Suspense>
      <WhatsAppButton offsetBottom="bottom-6 md:bottom-8" />
    </main>

  );
};


export default Index;
